import React from 'react';
import Dialog from 'components/pure/utils/Dialog';
import {List} from 'immutable';
import CoachingMeetingCategory from 'records/CoachingMeetingCategory';
import ToggleField from 'components/pure/utils/form/ToggleField';
import {ColorDot} from 'components/utils/ColorDot';
import CoachingReviewTypeActions from 'actions/coaching/CoachingReviewTypeActions';
import CoachingReviewTypeSource from 'sources/coaching/CoachingReviewTypeSource';
import './CoachingMeetingTypeChooser.styl';

interface Props {
  // tuple of category & and whether it is in use currently
  categories: List<{category: CoachingMeetingCategory; used: boolean}>;
  categoriesLoaded: boolean;
  open: boolean;
  onRequestClose: () => void;
}

const CoachingMeetingTypeChooser: React.FC<Props> = ({
  categories,
  categoriesLoaded,
  open,
  onRequestClose,
}) => {
  if (!categoriesLoaded) return null;

  const onToggleHidden = async (catId: number) => {
    await CoachingReviewTypeSource.toggleHidden(catId);
    CoachingReviewTypeActions.fetchAllReviewTypes(true);
    CoachingReviewTypeActions.fetchMeetingCategories(true);
  };

  return (
    <Dialog
      open={open}
      onRequestClose={onRequestClose}
      title={'Configure Meeting Category Visibility'}>
      <div className="meeting-category-visibility">
        <p>
          Note - you cannot hide any meeting categories that are currently in use. Either delete
          unused meeting types or change them to other categories.
        </p>
        <ul>
          {categories.map(({category, used}) => (
            <li>
              <div className="toggle">
                {!used ? (
                  <ToggleField
                    onToggle={() => onToggleHidden(category.id)}
                    value={!category.hidden}
                  />
                ) : (
                  <span className="in-use">&nbsp;(In Use)</span>
                )}
              </div>
              <ColorDot color={category.color} size={16} />
              <div>{category.name}</div>
            </li>
          ))}
        </ul>
      </div>
    </Dialog>
  );
};

export default CoachingMeetingTypeChooser;
